export enum FeatureFlag {
    Webhooks = 'Webhooks.Enabled',
    Monitoring = 'Monitoring.Enabled',
    Analytics = 'Insights.Enabled',
    MediaRecording = 'MediaRecording.Enabled',
    Tasks = 'Tasks.Enabled',
    AIFabric = 'AiFabric.Enabled',
    ManuallyRestartJob = 'ManuallyRestartJob.Enabled',
    ProcessSettingAutoStart = 'ProcessSettingAutoStart.Enabled',
    QueueSchemaDefinitions = 'QueueSchemaDefinitions.Enabled',
    Maintenance = 'MaintenanceMode.Enabled',
    LongRunningJobs = 'Features.LongRunning.Enabled',
    DirectoryService = 'DirectoryService.Enabled',
    SmartCardAuth = 'Features.SmartCardAuthentication.Enabled',
    LicenseLegacyMode = 'License.LegacyMode',
    QueueSlaMonitoring = 'Queue.SlaMonitoringEnabled',
    MultipleNonWorkingCalendars = 'MultipleNonWorkingLists.Enabled',
    PackagesViewer = 'PackagesViewer.Enabled',
    RestrictBasicAuth = 'Auth.RestrictBasicAuthentication',
}

export enum FeatureValues {
    Unknown = 'Unknown',
    True = 'True',
    False = 'False',
}

export interface IFeatureSetting {
    name: string;
    displayName: string;
    value: boolean | null;
    notEditable?: boolean;
    tooltip?: string;
}

export interface ITenantFeature {
    featureSettings: IFeatureSetting[];
    tenantId: string;
}
